import { createContext } from "react";

export interface ILoadingActionContext {
    setLoading: (key: string) => void;
    setLoaded: (key: string) => void;
    setValidating: (key: string) => void;
    setValid: (key: string) => void;
}

export const LoadingActionContext = createContext<ILoadingActionContext>({
    setLoading: () => {},
    setLoaded: () => {},
    setValidating: () => {},
    setValid: () => {}
});